import { CELL_ACTIONS, CELL_ACTION_TYPES } from "../actions/cells"
import { apiStatusInitialState, apiStatusStateType } from "../misc"
import produce, { enableES5} from "immer"
import { CellDataTypes } from '@cluster/web-components'

enableES5();

export interface CellsStateType {
  data: CellDataTypes.CellType[]
  pagination?: object;
  fetchStatus: apiStatusStateType
}

export const initialState: CellsStateType = {
  data: [],
  fetchStatus: apiStatusInitialState
}

export default (state = initialState, action: CELL_ACTION_TYPES): CellsStateType => {

  switch (action.type) {
    case CELL_ACTIONS.FETCH_CELLS_START:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          loading: true,
        }
      }
    case CELL_ACTIONS.FETCH_CELLS_SUCCESS:
      return {
        ...state,
        data: updateCells(state.data, action.payload?.data??[]),
        fetchStatus: {
          ...state.fetchStatus,
          lastFetch: Date.now(),
          errorCode: null,
          developerMessage: null,
          userMessage: null,
          moreInfo: null,
          lastError: null,
          loading: false
        }
      }
    case CELL_ACTIONS.FETCH_CELLS_ERROR:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    case CELL_ACTIONS.FETCH_CELL_DETAIL_START:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          loading: true,
        }
      }
    case CELL_ACTIONS.FETCH_CELL_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload ? updateCells(state.data, [action.payload]) : state.data,
        fetchStatus: {
          ...state.fetchStatus,
          lastFetch: Date.now(),
          errorCode: null,
          developerMessage: null,
          userMessage: null,
          moreInfo: null,
          lastError: null,
          loading: false
        }
      }
    case CELL_ACTIONS.FETCH_CELL_DETAIL_ERROR:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    case CELL_ACTIONS.CELLS_UPDATED:
      return {
        ...state,
        data: updateCells(state.data, action.payload??[]),
      }
    default:
      return state
  }
}

// Shared cell update implementation.
const updateCells = (currentCells: CellDataTypes.CellType[], payloadCells: CellDataTypes.CellType[]) => {
  return produce(currentCells, (draft: CellDataTypes.CellType[]) => {
    for(const payloadCell of payloadCells) {
      let existingCellId = draft.findIndex(cell => cell.id === payloadCell.id);

      if (existingCellId !== -1) {
        draft[existingCellId] = payloadCell;
      } else {
        draft.push(payloadCell);
      }
    }
  })
}
